import { DecoratorNode } from "lexical";

export class VariableNode extends DecoratorNode {
  __variableName;
  __displayName;

  static getType() {
    return "variable";
  }

  static clone(node) {
    return new VariableNode(
      node.__variableName,
      node.__displayName,
      node.__key
    );
  }

  constructor(variableName, displayName, key) {
    super(key);
    this.__variableName = variableName;
    this.__displayName = displayName;
  }

  createDOM() {
    const span = document.createElement("span");
    span.className = "variable-chip";
    span.setAttribute("contenteditable", "false");
    span.textContent = this.__displayName;
    return span;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return null;
  }

  exportDOM() {
    const element = document.createTextNode(`{{${this.__variableName}}}`);
    return { element };
  }

  static importDOM() {
    return null;
  }

  getTextContent() {
    return `{{${this.__variableName}}}`;
  }

  isInline() {
    return true;
  }

  exportJSON() {
    return {
      type: "variable",
      variableName: this.__variableName,
      displayName: this.__displayName,
      version: 1,
    };
  }

  static importJSON(json) {
    return new VariableNode(json.variableName, json.displayName);
  }
}

export function $createVariableNode(variableName, displayName) {
  return new VariableNode(variableName, displayName);
}

export function $isVariableNode(node) {
  return node instanceof VariableNode;
}
